export default {
  currentUser (state) {
    return state.currentUser
  },
  role (state) {
    return state.currentUser.role
  },
  users (state) {
    return state.users
  },
  divisions (state) {
    return state.divisions
  }
}
